import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    icon: '🧭',
    title: 'Un camino claro día a día',
    desc: '21 días de prácticas secuenciadas. Sin improvisar, sin preguntarte qué hacer hoy. Solo seguir el sistema.'
  }, {
    icon: '🛡️',
    title: 'Herramientas para el momento del impulso',
    desc: 'Dejas de estar indefenso/a cuando el ciclo jala más fuerte. Tienes una respuesta lista.'
  }, {
    icon: '🔓',
    title: 'La culpa deja de ser el puente de regreso',
    desc: 'Trabajas con la culpa en lugar de suprimirla. Eso rompe la conexión que la convierte en disparador.'
  }, {
    icon: '⏱️',
    title: 'Prácticas de 5 a 15 minutos',
    desc: 'Sin disrumpir tu vida. Sin excusas de tiempo. Si tienes tiempo para el ciclo, tienes tiempo para interrumpirlo.'
  }, {
    icon: '🤝',
    title: 'Lenguaje sin juicio ni etiquetas',
    desc: 'Te acompañas a ti mismo/a en lugar de atacarte. El proceso es amable con quien lo hace.'
  }, {
    icon: '🔒',
    title: '100% privado',
    desc: 'Nadie necesita saber que estás trabajando en esto. Es entre tú y el proceso.'
  }];
  return <section className="py-6 md:py-9 px-5 bg-gradient-to-b from-card-bg to-dark-bg" data-id="element-14" data-mp="2l5iikr3cztc4">
      <div className="max-w-[900px] mx-auto" data-id="element-15" data-mp="2g65wi8kbaqal">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-16" data-mp="2g6fk5phvwld4">
          Lo que obtienes
        </span>

        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-17" data-mp="1ofhvqxmjvmxg">
          No más información.
          <br data-id="element-18" data-mp="22g2b1jt9b0m7" />
          <span className="text-gradient-magenta" data-id="element-19" data-mp="22cek8sf74sb6">Herramientas reales.</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-3 mt-4" data-id="element-20" data-mp="1xe3a0gkzofsf">
          {benefits.map((benefit, idx) => <div key={idx} className="bg-gradient-to-br from-[rgba(107,0,182,0.12)] to-[rgba(194,0,111,0.08)] border border-[rgba(107,0,182,0.3)] rounded-2xl p-4 transition-all duration-300 hover:-translate-y-[5px] hover:border-magenta hover:shadow-[0_10px_40px_rgba(194,0,111,0.2)]" data-id="element-21" data-mp="38v333ef5uyni" data-mpi={idx}>
              <div className="text-[2rem] mb-2" data-id="element-22" data-mp="3px8tdjj9h6ht">{benefit.icon}</div>
              <h4 className="text-[1.05rem] font-heading font-extrabold text-white mb-1" data-id="element-23" data-mp="3uvk21qxtlayg">
                {benefit.title}
              </h4>
              <p className="text-[0.9rem] leading-[1.5] text-white/70" data-id="element-24" data-mp="2x8uw55zzye7b">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}